<template>
  <!--统一安全验证-->
  <!--  web 端-->
  <div v-if="pageType === 'web'">
    <a-modal
      class="bind-phone-modal"
      :visible="verifyVisible"
      @cancel="verifyVisible=false"
      :destroyOnClose="true"
      :centered="true"
      :footer="null"
    >
      <h3 class="title">安全验证</h3>
      <div class="tip">
        <p>为确认身份，我们仍需验证您的安全手机</p>
        <p>点击发送短信按钮，将会发送一条有验证码的短信至手机</p>
        <p>{{userMobile}}</p>
      </div>

      <!-- 第一步-->
      <a-button v-if="verifyStep === 1" @click="getCode(1, 'verifyStep')" type="primary" block>发送验证码</a-button>

      <!-- 第二步-->
      <template v-if="verifyStep === 2">
        <div class="check-code">
          <span class="text">请输入6位数字验证码</span>
          <span v-if="second" class="text">{{second + 'S'}}</span>
          <span v-else class="text" @click="getCode(1, 'verifyStep')">重新发送</span>
        </div>
        <div class="btn-group">
          <template v-for="(item, index) of phoneCode.list" :key="index">
            <a-input
              class="phone-code-input"
              @keydown="event => phoneCodeKeydown(event, index)"
              @change="val => phoneCodeChange(val, item, index)"
              v-model:value="item.value"
              type="text" inputmode="numeric" autocomplete="one-time-code"
            ></a-input>
          </template>
        </div>

        <a-button
          @click="getSecretKey"
          :disabled="phoneCode.list.some(item => item.value === '')"
          type="primary"
          block>下一步</a-button>
      </template>
    </a-modal>
  </div>

  <!-- 移动端 端-->
  <div class="safe-verify view-box" v-if="pageType !== 'web' && checkVisible">
    <navBan :goBack="closeModal" title="安全验证"></navBan>
    <div class="tip-info">
      <p>为确认身份，我们仍需验证您的安全手机</p>
      <p>点击发送短信按钮，将会发送一条有验证码的短信</p>
      <p>至手机 {{userMobile}}</p>
    </div>

    <button v-if="verifyStep === 1" @click="getCode(1, 'verifyStep')" class="button">发送验证码</button>

    <div v-if="verifyStep === 2">
      <div class="check-code">
        <span class="text">请输入6位数字验证码</span>
        <span v-if="second" class="text">{{second + 'S'}}</span>
        <span v-else class="text" @click="getCode(1, 'verifyStep')">重新发送</span>
      </div>
      <div class="btn-group">
        <template v-for="(item, index) of phoneCode.list" :key="index">
          <a-input
            class="m-input phone-code-input"
            @keydown="event => phoneCodeKeydown(event, index)"
            @change="val => phoneCodeChange(val, item, index)"
            v-model:value="item.value"
            type="text" inputmode="numeric" autocomplete="one-time-code"
          ></a-input>
        </template>
      </div>

      <button
        @click="getSecretKey"
        style="margin-top: 16px"
        class="button"
        :class="{ 'button-disabled': phoneCode.list.some(item => item.value === '') }"
        :disabled="phoneCode.list.some(item => item.value === '')"
      >
        <LoadingOutlined class="icon-loading"/>下一步
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, defineExpose, defineEmits, defineProps, computed } from 'vue';
import Common from '@/utils/common';
import { GET, POST } from '@/packge/http';
import { phoneCode, phoneCodeChange, phoneCodeKeydown, prePhoneCode, countDown, second } from '@/utils/setup/captchaInput'; // todo 重复了
import navBan from '@/components/navBan';
import store from '@/store';
import { onBeforeRouteLeave } from 'vue-router';

const emit = defineEmits(['updateName', 'handleOperate', 'updateCheckVisible']);
const props = defineProps({
  pageType: { default: () => 'web' },
  checkVisible: Boolean
});
let operateType = reactive({});
let verifyStep = ref(1);
let verifyVisible = ref(false);
const userMobile = ref('');

userMobile.value = computed(() => store.state.userInfo.phonenumber || sessionStorage.getItem('phonenumber'));

function closeModal () {
  this.$router.go('-1');
}
/** 操作登录方式状态 */
async function operateState (item) {
  operateType = item;

  const key = localStorage.getItem('operateSecretKey');
  if (!key) {
    props.pageType === 'web' ? verifyVisible.value = true : emit('updateCheckVisible', true);
    return;
  } else {
    const valid = await verifySecretKey(key);
    if (!valid) {
      // verifyVisible.value = true;
      props.pageType === 'web' ? verifyVisible.value = true : emit('updateCheckVisible', true);
      return;
    }
  }

  emit('handleOperate', item);
}

/** 验证秘钥是否过期 */
function verifySecretKey (key) {
  return new Promise((resolve, reject) => {
    GET({
      url: '/account/authSecretKey',
      params: { secretKey: key }
    }).then(({ data }) => {
      if (data.status === 1) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  });
}

/** 统一 获取手机验证码 */
function getCode (type) {
  if (second.value > 0) { return; }

  GET({
    url: '/account/getSmsCode',
    params: {
      type // 1安全认证 2绑定手机 3绑定邮箱
    }
  }).then(({ data }) => {
    verifyStep.value === 1 && verifyStep.value++;
    countDown();
  });
}

/** 通过验证码，获得秘钥 */
function getSecretKey () {
  POST({
    url: '/account/checkSmsCode',
    params: {
      code: prePhoneCode(),
      type: 1
    }
  }).then(({ data }) => {
    localStorage.setItem('operateSecretKey', data.secretKey);
    phoneCode.list.forEach(item => {
      item.value = '';
    });

    if (props.pageType === 'web') {
      verifyVisible.value = false;
    } else {
      emit('updateCheckVisible', false);
    }
    // verifyStep.value--;
    emit('handleOperate', operateType);
  });
}

onBeforeRouteLeave(() => {
  second.value = 0;
  phoneCode.list.forEach(item => {
    item.value = '';
  });
});

defineExpose({
  getCode,
  operateState
});
</script>

<style lang="scss" scoped>
.safe-verify {
  position: fixed;
  top: 0;
  left: 0;
}
</style>
